// Identificación del cliente (app + versión) para telemetría en los headers
// `X-Client-App` / `X-Client-Version` que envía ApiCore en cada llamada
// autenticada. Fase actual: solo telemetría (medir % de tráfico por versión),
// sin ningún efecto funcional ni de control de acceso.
//
// Módulo puro (sin React/Zustand/Sentry, sin leer `import.meta.env`): mismo
// patrón y misma prohibición de mockearlo en tests de sus consumidores que
// src/lib/oneclickCards.js / src/lib/mpCheckout.js / src/lib/transbankCredenciales.js.
//
// `__APP_VERSION__` es una constante inyectada en build time por Vite (bloque
// `define` de vite.config.js / vitest.config.js), no una env var — por eso no
// se lee acá vía getEnvVariables().

/**
 * getClientApp()
 * Identificador literal y constante de esta app. Nunca cambia en runtime.
 */
export const getClientApp = () => "openmatic-web";

/**
 * getClientVersion()
 * Lectura defensiva de la global `__APP_VERSION__` inyectada en build. Nunca
 * lanza y nunca devuelve `undefined` ni la cadena `"undefined"` (p. ej. si el
 * `define` faltara o `pkg.version` viniera vacío en un entorno mal configurado).
 */
export const getClientVersion = () => {
  try {
    const version =
      typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "desconocida";
    if (!version || typeof version !== "string" || version === "undefined") {
      return "desconocida";
    }
    return version;
  } catch {
    return "desconocida";
  }
};
